import React, { useEffect, useState } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './lootBox.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, Selectize, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';
import { useNavigate } from 'react-router-dom';
import { REWARDS } from '~/config/constants';
import { fetchRewardApi } from '../Reward/rewardSlice';

LootBoxForm.defaultProps = {
    pictureAttributeNames: null,
};
LootBoxForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function LootBoxForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);
    const [notes, setNotes] = useState([]);

    const reward = useSelector((state) => state.itemSaga.reward);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchRewardApi(navigate));
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(lootBoxMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            enableReinitialize={true}
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values, setFieldValue } = props;

                                const onAddDrop = () => {
                                    setFieldValue('drops', [...values.drops, []])
                                    setNotes([...notes, '']);
                                }

                                const onDeleteDrop = (i) => {
                                    let tmp = JSON.parse(JSON.stringify(values.drops));
                                    tmp.splice(i, 1);
                                    setFieldValue('drops', tmp)

                                    let tmp2 = JSON.parse(JSON.stringify(notes));
                                    tmp2.splice(i, 1);
                                    setNotes(tmp2);
                                }

                                const setDrop = (arr, i) => {
                                    let percent = 0;
                                    for (let drop of arr) {
                                        percent += parseInt(reward.rows.find(obj => obj.id == drop).rate);
                                    }
                                    let tmp = JSON.parse(JSON.stringify(notes));
                                    tmp[i] = `${percent}% `;
                                    if (percent < 100)
                                        tmp[i] += `please fill more reward`;
                                    else if (percent > 100)
                                        tmp[i] += `please remove reward`;
                                    else
                                        tmp[i] += `good job`;
                                    setNotes(tmp);
                                }

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <Form.Row className="d-flex justify-content-between">
                                            <FormText
                                                sm="3"
                                                name="name"
                                                className="d-flex flex-column justify-content-end"
                                            />
                                            {pictureAttributeNames.map((imgName, i) => (
                                                <Col
                                                    key={i}
                                                    sm={3}
                                                >
                                                    <FileUploadedWithResetCount
                                                        pictureName={imgName}
                                                        pictureVal={values[imgName]}
                                                        resetCount={resetCount}
                                                        id={imgName}
                                                    />
                                                </Col>
                                            ))}
                                        </Form.Row>
                                        <Form.Row className="d-flex justify-content-between">
                                            <TextArea
                                                name={'description'}
                                                sm={3}
                                                rows={4}
                                            />
                                             <FormNumber
                                                sm="3"
                                                label="Open duration (second)"
                                                name="open_duration"
                                                className="d-flex flex-column"
                                            />
                                        </Form.Row>
                                        <button className="ch-50" type="button" onClick={onAddDrop}>Add more drop</button>
                                        <Form.Row className="mt-3">
                                            {
                                                values.drops.map((name, i) => {
                                                    return (
                                                        <div className='col-sm-6'>
                                                            <Selectize
                                                                key={i}
                                                                name={`drops[${i}]`}
                                                                options={reward.rows}
                                                                sm={12}
                                                                label="Drop"
                                                                note={notes[i]}
                                                                setReplacements={(arr) => setDrop(arr, i)}
                                                            />
                                                            <button type="button" onClick={() => onDeleteDrop(i)}>Delete drop</button>

                                                        </div>
                                                    );
                                                })
                                            }
                                        </Form.Row>

                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default LootBoxForm;
